import { ImageViewFill, ImageViewFit } from '../../image/image-print';
import { ImageContainer } from '../../image/image.style';
import { getPrintImage } from '../../shared/logic/get-print-image';
import { MultipleChoiceOption } from '../multiple-choice.constants';
import { isImageLayoutFill } from '../multiple-choice.utils';

const MultipleChoiceImagePrint = ({
  option,
  previewSize,
}: {
  option: MultipleChoiceOption;
  previewSize?: number;
}) => {
  const imageUrl = getPrintImage(option.imageUrls, previewSize);

  return (
    <ImageContainer fullBorderRadius>
      {isImageLayoutFill(option.imageLayout) ? (
        <ImageViewFill altText={option.image?.alt} imageUrl={imageUrl} />
      ) : (
        <ImageViewFit altText={option.image?.alt} imageUrl={imageUrl} />
      )}
    </ImageContainer>
  );
};
export default MultipleChoiceImagePrint;
